import { env, isDevelopment } from './env';
import { localPort } from './ports';
import { webConfig } from './webConfig';

/** Local Hive endpoint, served by the hive-ingress worker. */
export const HIVE_DEV_ENDPOINT = `http://127.0.0.1:${localPort(6222)}`;
/** Local Hive V2 cluster, which the ingress forwards V2 content to. */
export const HIVE_CLUSTER_DEV_URL = `http://127.0.0.1:${localPort(6223)}`;
const HIVE_V1_DEV_ENDPOINT = `http://127.0.0.1:${localPort(7001)}`;

/**
 * Return the fully qualified Hive domain with protocol.
 */
export function getHiveEndpointFromEnv(): string {
    if (isDevelopment || env === 'test') {
        return HIVE_DEV_ENDPOINT;
    }

    return `https://v2-${webConfig.services.content.host}`;
}

/**
 * Return the fully qualified Hive V1 domain with protocol.
 */
export function getHiveV1EndpointFromEnv(): string {
    if (process.env.FIRESTORE_EMULATOR_HOST) {
        return HIVE_V1_DEV_ENDPOINT;
    }

    if (env === 'test') {
        return `http://localhost:${localPort(7001)}`;
    }

    // TODO: V1 doesn't use localhost for testing? Investigate why later.
    return `https://${webConfig.services.content.host}`;
}

/**
 * Return the fully qualified URL for the Agent runtime.
 */
export function getContentAgentsEndpoint(): string {
    if (isDevelopment) {
        return `http://localhost:${localPort(6322)}`;
    }
    return getHiveEndpointFromEnv();
}

/**
 * Return the fully qualified URL for Hive file storage.
 * This _cannot_ differ between V1/V2 as it would break file access between the two versions.
 */
export function getHiveFileBaseURL(): string {
    if (process.env.FIRESTORE_EMULATOR_HOST) {
        return HIVE_V1_DEV_ENDPOINT;
    }

    return `https://${webConfig.services.content.host}`;
}

export function isHiveV2Project(): boolean {
    if (process.env.HIVE_V2 === 'true') {
        return true;
    }

    return (
        webConfig.firebase.projectId === 'gitbook-x-dev-john' ||
        webConfig.firebase.projectId === 'getsquad-dev-steven' ||
        webConfig.firebase.projectId === 'gitbook-x-dev-nicolas' ||
        webConfig.firebase.projectId === 'gitbook-x-dev-antoine' ||
        webConfig.firebase.projectId === 'gitbook-x-dev-viktor'
    );
}
